<template>
  <div class="app-container">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>接送机订单管理</span>
        </div>
      </template>
      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item label="订单号">
          <el-input v-model="searchForm.order_sn" placeholder="请输入订单号" />
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="searchForm.contact_name" placeholder="请输入联系人姓名" />
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="searchForm.contact_phone" placeholder="请输入联系电话" />
        </el-form-item>
        <el-form-item label="订单类型">
          <el-select v-model="searchForm.order_type" placeholder="请选择订单类型" clearable >
            <el-option label="接机" value="1" />
            <el-option label="送机" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable >
            <el-option label="待确认" value="1" />
            <el-option label="已确认" value="2" />
            <el-option label="已完成" value="3" />
            <el-option label="已评价" value="4" />
            <el-option label="已取消" value="5" />
          </el-select>
        </el-form-item>
        <el-form-item label="落地时间">
          <el-date-picker
            v-model="searchForm.timeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchClick">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="list" style="width: 100%">
        <el-table-column prop="order_sn" label="订单号" width="180" />
        <el-table-column prop="order_type" label="订单类型" width="100">
          <template #default="scope">
            {{ orderStatus(scope.row.order_type) === 1 ? '接机' : '送机' }}
          </template>
        </el-table-column>
        <el-table-column prop="flight_departure_time" label="航班起飞时间" width="180" />
        <el-table-column prop="appointment_time" label="航班落地时间" width="180" />
        <el-table-column prop="flight_number" label="航班号" width="120" />
        <el-table-column prop="contact_name" label="联系人" width="100" />
        <el-table-column prop="contact_phone" label="联系电话" width="120" />
        <el-table-column prop="status" label="状态" width="100">
          <template #default="scope">
            <el-tag v-if="orderStatus(scope.row.status) === 1" type="warning">待确认</el-tag>
            <el-tag v-else-if="orderStatus(scope.row.status) === 2" type="info">已确认</el-tag>
            <el-tag v-else-if="orderStatus(scope.row.status) === 3" type="success">已完成</el-tag>
            <el-tag v-else-if="orderStatus(scope.row.status) === 4" type="primary">已评价</el-tag>
            <el-tag v-else-if="orderStatus(scope.row.status) === 5" type="danger">已取消</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="tw_order_num" label="工单号" width="150" />
        <el-table-column prop="tw_status" label="工单状态" width="100">
          <template #default="scope">
            <el-tag v-if="scope.row.tw_status" type="info">{{ scope.row.tw_status }}</el-tag>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180" />
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="scope">
            <el-button type="primary" size="small" @click="handleDetail(scope.row)">详情</el-button>
            <el-button v-if="orderStatus(scope.row.status) === 1 || orderStatus(scope.row.status) === 2" type="danger" size="small" @click="handleCancel(scope.row)">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total"
        :total="total"
        :page.sync="queryParam.page"
        :limit.sync="queryParam.size"
        :page-sizes="[10, 20, 30, 50, 100]"
        @pagination="getList"
      />
    </el-card>

    <el-drawer custom-class="custom-drawer" :visible.sync="detailDialogVisible" :close-on-press-escape="false"
    :wrapper-closable="false" :show-close="false" size="720px" direction="rtl">
    <template slot="title">
      <div class="custom-title">
        <div class="title-name">订单详情</div>
        <i class="el-icon-circle-close close-btn pointer" @click="detailDialogVisible = false" />
      </div>
    </template>
    <div
      class="custom-content"
      v-loading="detailLoading"
      element-loading-text="加载中..."
      element-loading-background="rgba(255, 255, 255, 0.9)"
    >
      <div v-if="orderDetail && Object.keys(orderDetail).length">
      <div class="detail-card top-card">
        <div class="status-title">{{ getStatusText(orderDetail.status) }}</div>
        <div class="status-desc">{{ getStatusDesc(orderDetail.status) }}</div>
      </div>

      <div class="detail-card">
        <div class="card-title">预约信息</div>
        <div class="item"><div class="label">订单号</div><div class="value">{{ orderDetail.order_sn || '--' }}</div></div>
        <div class="item"><div class="label">预约类型</div><div class="value">{{ orderDetail.order_type === 1 ? '接机' : '送机' }}</div></div>
        <div class="item"><div class="label">航班起飞时间</div><div class="value">{{ orderDetail.flight_departure_time || '--' }}</div></div>
        <div class="item"><div class="label">航班落地时间</div><div class="value">{{ orderDetail.appointment_time || '--' }}</div></div>
        <div class="item"><div class="label">航班号</div><div class="value">{{ orderDetail.flight_number || '--' }}</div></div>
        <div class="item"><div class="label">上车地点</div><div class="value">{{ orderDetail.pickup_address || '--' }}</div></div>
      </div>

      <div class="detail-card">
        <div class="card-title">联系人信息</div>
        <div class="item"><div class="label">姓名</div><div class="value">{{ orderDetail.contact_name || '--' }}</div></div>
        <div class="item"><div class="label">电话</div><div class="value">{{ orderDetail.contact_phone || '--' }}</div></div>
      </div>

      <div class="detail-card">
        <div class="card-title">乘车信息</div>
        <div class="item"><div class="label">大人人数</div><div class="value">{{ (orderDetail.adult_count || 0) + '人' }}</div></div>
        <div class="item"><div class="label">小孩人数</div><div class="value">{{ (orderDetail.child_count || 0) + '人' }}</div></div>
        <div class="item"><div class="label">老人人数</div><div class="value">{{ (orderDetail.elderly_count || 0) + '人' }}</div></div>
        <div class="item"><div class="label">行李情况</div><div class="value">{{ orderDetail.luggage_info || '--' }}</div></div>
        <div class="item"><div class="label">特殊情况</div><div class="value">{{ getSpecialText(orderDetail) }}</div></div>
        <div class="item" v-if="orderDetail.remark"><div class="label">备注</div><div class="value">{{ orderDetail.remark }}</div></div>
      </div>

      <div class="detail-card" v-if="orderDetail.tw_order_id || orderDetail.tw_status">
        <div class="card-title">工单信息</div>
        <div class="item" v-if="orderDetail.tw_order_num"><div class="label">工单号</div><div class="value">{{ orderDetail.tw_order_num }}</div></div>
        <div class="item" v-if="orderDetail.tw_status"><div class="label">工单状态</div><div class="value">{{ orderDetail.tw_status }}</div></div>
      </div>

      <div class="detail-card" v-if="orderDetail.tw_order_id || flowList.length || twDetailLoading" v-loading="twDetailLoading" element-loading-text="同步工单进度...">
        <div class="card-title">处理流程</div>
        <div class="steps">
          <div class="steps-item" v-for="(item, idx) in flowList" :key="idx">
            <div class="steps-line"></div>
            <div class="steps-dot-wrap">
              <div class="steps-dot" :class="{ active: idx === 0 }"></div>
            </div>
            <div class="steps-content">
              <div class="steps-title">
                {{ item.incidentAction || '--' }}
                <span class="steps-user">{{ getDealUserName(item) }}</span>
              </div>
              <div class="steps-text" v-if="item.content">{{ idx === 0 ? '内容' : '处理内容' }}:{{ item.content }}</div>
              <div class="steps-text" v-if="item.dealUserTel">{{ idx === 0 ? '电话' : '处理人电话' }}:{{ item.dealUserTel }}</div>
              <div class="steps-text">{{ idx === 0 ? '时间' : '处理时间' }}:{{ item.dealTime || '--' }}</div>
              <div class="steps-images" v-if="getFlowImages(item).length">
                <el-image
                  v-for="(img, imgIdx) in getFlowImages(item)"
                  :key="imgIdx"
                  :src="img"
                  :preview-src-list="getFlowImages(item)"
                  fit="cover"
                  class="steps-image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-card" v-if="orderDetail.sign_xingming">
        <div class="card-title">服务协议</div>
        <el-image
          :src="getSignImageUrl(orderDetail.sign_xingming)"
          :preview-src-list="[getSignImageUrl(orderDetail.sign_xingming)]"
          fit="contain"
          style="width: 100%;"
        />
      </div>

      <div class="detail-card">
        <div class="card-title">其他信息</div>
        <div class="item"><div class="label">创建时间</div><div class="value">{{ orderDetail.created_at || '--' }}</div></div>
        <div class="item" v-if="orderDetail.status === 5"><div class="label">取消原因</div><div class="value">{{ orderDetail.cancel_reason || '--' }}</div></div>
        <template v-if="orderDetail.status === 4">
          <div class="item"><div class="label">评价评分</div><div class="value">{{ (orderDetail.score || 0) + '分' }}</div></div>
          <div class="item"><div class="label">评价内容</div><div class="value">{{ orderDetail.comment_content || '--' }}</div></div>
        </template>
      </div>
      </div>
    </div>
    </el-drawer>

    <el-dialog title="取消订单" :visible.sync="cancelDialogVisible" width="500px" append-to-body>
      <el-form :model="cancelForm">
        <el-form-item label="取消原因">
          <el-input v-model="cancelForm.reason" type="textarea" placeholder="请输入取消原因" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancelDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitCancel">确认取消</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import JiejiOrder from "@/api/tianzheng/jiejiorder";
import Pagination from "@/components/Pagination";

export default {
  components: {
    Pagination
  },
  data() {
    return {
      list: [],
      total: 0,
      queryParam: {
        page: 1,
        size: 10
      },
      searchForm: {
        order_sn: '',
        contact_name: '',
        contact_phone: '',
        order_type: '',
        status: '',
        timeRange: []
      },
      detailDialogVisible: false,
      detailLoading: false,
      twDetailLoading: false,
      orderDetail: {},
      cancelDialogVisible: false,
      cancelForm: {
        reason: '',
        orderId: ''
      }
    }
  },
  created() {
    this.getList()
  },
  computed: {
    flowList() {
      const twDetail = this.orderDetail && this.orderDetail.twDetail ? this.orderDetail.twDetail : {}
      return Array.isArray(twDetail.flowList) ? twDetail.flowList : []
    }
  },
  methods: {
    getStatusDesc(status) {
      switch (Number(status)) {
        case 1: return '订单已提交，等待物业确认'
        case 2: return '订单已确认，等待服务'
        case 3: return '服务已完成，感谢您的使用'
        case 4: return '订单已评价，期待再次为您服务'
        case 5: return '订单已取消'
        default: return ''
      }
    },
    getSpecialText(detail) {
      if (!detail) return '--'
      const specialList = []
      if (detail.is_handicapped) specialList.push('老人行动不便')
      if (detail.is_carsick) specialList.push('晕车')
      return specialList.length ? specialList.join('、') : '无'
    },
    getDealUserName(item) {
      if (!item) return '无'
      const matchSelfAction = ['报事提交', '报事工单催办', '报事回访', '提交', '工单催办', '回访']
      const action = item.incidentAction || ''
      if (matchSelfAction.includes(action) && !item.dealUserName) {
        return this.orderDetail && this.orderDetail.contact_name ? this.orderDetail.contact_name : '无'
      }
      return item.dealUserName || '无'
    },
    getFlowImages(item) {
      if (!item || !item.accessoryList) return []
      const imgs = item.accessoryList.img
      return Array.isArray(imgs) ? imgs.filter(Boolean) : []
    },
    getList() {
      const range = Array.isArray(this.searchForm.timeRange) ? this.searchForm.timeRange : []
      const search = {
        order_sn: this.searchForm.order_sn,
        contact_name: this.searchForm.contact_name,
        contact_phone: this.searchForm.contact_phone,
        order_type: this.searchForm.order_type,
        status: this.searchForm.status,
        start_time: range[0] ? range[0] + ' 00:00:00' : '',
        end_time: range[1] ? range[1] + ' 23:59:59' : ''
      }
      JiejiOrder.list({
        page: this.queryParam.page,
        pageSize: this.queryParam.size,
        search: search
      }).then(res => {
        if (res.code === 200) {
          this.list = res.result.list
          this.total = res.result.total
        }
      })
    },
    searchClick() {
      this.queryParam.page = 1
      this.getList()
    },
    resetForm() {
      this.searchForm = {
        order_sn: '',
        contact_name: '',
        contact_phone: '',
        order_type: '',
        status: '',
        timeRange: []
      }
      this.queryParam.page = 1
      this.queryParam.size = 10
      this.getList()
    },
    handleDetail(row) {
      const id = (row && (row.id || row.order_id || row.orderId)) || ''
      if (!id) {
        this.$message.error('订单ID缺失，无法查看详情')
        return
      }
      this.orderDetail = {}
      this.detailLoading = true
      this.twDetailLoading = false
      this.detailDialogVisible = true
      JiejiOrder.detailBase({ id: id })
        .then(res => {
          if (res.code === 200) {
            this.orderDetail = res.result || {}
            this.detailLoading = false
            const needTw = this.orderDetail && this.orderDetail.tw_order_id && this.orderDetail.resourceId
            if (needTw) {
              this.twDetailLoading = true
              JiejiOrder.detailTw({ id: id })
                .then(res2 => {
                  if (res2.code === 200) {
                    this.orderDetail = res2.result || this.orderDetail
                  } else {
                    this.$message.warning(res2.message || res2.msg || '工单进度同步失败')
                  }
                })
                .catch(() => {
                  this.$message.warning('工单进度同步失败')
                })
                .finally(() => {
                  this.twDetailLoading = false
                })
            }
          } else {
            this.$message.error(res.message || res.msg || '获取订单详情失败')
            this.detailDialogVisible = false
          }
        })
        .catch(() => {
          this.$message.error('获取订单详情失败')
          this.detailDialogVisible = false
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    orderStatus(status) {
      if (status === null || status === undefined || status === '') return status
      const n = Number(status)
      return Number.isNaN(n) ? status : n
    },
    handleCancel(row) {
      const id = row && (row.id != null ? row.id : row.order_id)
      if (id == null || id === '') {
        this.$message.error('订单ID不存在')
        return
      }
      this.cancelForm.orderId = id
      this.cancelForm.reason = ''
      this.cancelDialogVisible = true
    },
    submitCancel() {
      JiejiOrder.edit({
        id: this.cancelForm.orderId,
        status: 5,
        cancel_reason: this.cancelForm.reason
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('取消成功')
          this.cancelDialogVisible = false
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getSignImageUrl(path) {
      if (!path) return ''
      const baseUrl = (this.$publicData && this.$publicData.imgUrl) || ''
      if (/^https?:\/\//i.test(path)) return path
      return baseUrl + path
    },
    getStatusText(status) {
      switch (Number(status)) {
        case 1: return '待确认'
        case 2: return '已确认'
        case 3: return '已完成'
        case 4: return '已评价'
        case 5: return '已取消'
        default: return ''
      }
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-content {
  height: 100%;
  min-height: 200px;
  overflow-y: auto;
  background: #f5f7fa;
  padding: 12px;
}

.detail-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
}

.top-card {
  background: linear-gradient(135deg, #f14646, #f9f9f9);
  color: #fff;
}

.status-title {
  font-size: 22px;
  font-weight: 600;
}

.status-desc {
  margin-top: 6px;
  font-size: 14px;
  opacity: 0.95;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;
}

.item {
  display: flex;
  align-items: flex-start;
  line-height: 22px;
  margin-bottom: 8px;
}

.item:last-child {
  margin-bottom: 0;
}

.label {
  width: 92px;
  color: #909399;
  flex-shrink: 0;
}

.value {
  color: #303133;
  word-break: break-all;
}

.steps {
  position: relative;
}

.steps-item {
  position: relative;
  display: flex;
  padding-bottom: 14px;
}

.steps-item:last-child {
  padding-bottom: 0;
}

.steps-line {
  position: absolute;
  left: 7px;
  top: 14px;
  bottom: -2px;
  width: 1px;
  background: #e4e7ed;
}

.steps-item:last-child .steps-line {
  display: none;
}

.steps-dot-wrap {
  width: 16px;
  margin-right: 10px;
}

.steps-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #dcdfe6;
  margin-top: 2px;
}

.steps-dot.active {
  background: #409eff;
}

.steps-content {
  flex: 1;
}

.steps-title {
  color: #303133;
  font-weight: 600;
}

.steps-user {
  margin-left: 8px;
  font-weight: 400;
  color: #909399;
}

.steps-text {
  margin-top: 4px;
  color: #606266;
  line-height: 20px;
}

.steps-images {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.steps-image {
  width: 72px;
  height: 72px;
  border-radius: 4px;
}
</style>
